import React, { useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV = [
  { to: '/dashboard',              label: 'Overview',       end: true },
  { to: '/dashboard/assets',       label: 'My Assets'               },
  { to: '/dashboard/purchases',    label: 'Purchases'               },
  { to: '/dashboard/requests',     label: 'Data Requests'           },
  { to: '/dashboard/subscriptions',label: 'Subscriptions'           },
  { to: '/dashboard/settings',     label: 'Settings'                },
];

const SALES = { to: '/dashboard/sales', label: 'Sales' };

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const hasSales = (user?.sellerStats?.totalSales || 0) > 0;
  const nav = hasSales ? [...NAV.slice(0, 2), SALES, ...NAV.slice(2)] : NAV;

  const handleLogout = async () => { await logout(); navigate('/'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg)' }}>
      {/* Sidebar */}
      <aside style={{
        width: collapsed ? 52 : 210, flexShrink: 0, background: 'var(--surface)',
        borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column',
        position: 'sticky', top: 0, height: '100vh', transition: 'width 0.2s', overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{ padding: collapsed ? '14px 0' : '16px 16px', display: 'flex', alignItems: 'center', borderBottom: '1px solid var(--border)', gap: 8 }}>
          {!collapsed && (
            <Link to="/" style={{ fontWeight: 700, fontSize: 15, color: 'var(--text)', textDecoration: 'none', flex: 1, letterSpacing: '-0.3px' }}>
              dApiary
            </Link>
          )}
          <button onClick={() => setCollapsed(!collapsed)} style={{
            background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-3)',
            fontSize: 11, padding: 4, marginLeft: collapsed ? 'auto' : 0, display: 'flex',
          }}>
            {collapsed ? '›' : '‹'}
          </button>
        </div>

        {/* User */}
        {!collapsed && user && (
          <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'var(--accent-bg)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, flexShrink: 0 }}>
              {(user.name || 'U')[0]}
            </div>
            <div style={{ overflow: 'hidden' }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user.name}</div>
              <div style={{ fontSize: 11, color: 'var(--accent)', fontFamily: 'Space Mono' }}>${(user.balance || 0).toFixed(2)}</div>
            </div>
          </div>
        )}

        {/* Nav */}
        <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto' }}>
          {nav.map(({ to, label, end }) => (
            <NavLink key={to} to={to} end={end} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center',
              padding: collapsed ? '9px 0' : '8px 16px',
              justifyContent: collapsed ? 'center' : 'flex-start',
              textDecoration: 'none', fontSize: 13, fontWeight: isActive ? 600 : 400,
              color: isActive ? 'var(--accent)' : 'var(--text-2)',
              background: isActive ? 'var(--accent-bg)' : 'transparent',
              borderRight: isActive ? '2px solid var(--accent)' : '2px solid transparent',
              transition: 'all 0.12s',
            })} title={collapsed ? label : undefined}>
              {collapsed
                ? <span style={{ fontSize: 12, fontWeight: 700, color: 'inherit' }}>{label[0]}</span>
                : label
              }
            </NavLink>
          ))}
        </nav>

        {/* Logout */}
        <div style={{ borderTop: '1px solid var(--border)', padding: '8px 0' }}>
          <button onClick={handleLogout} style={{
            display: 'flex', alignItems: 'center', width: '100%',
            padding: collapsed ? '9px 0' : '8px 16px',
            justifyContent: collapsed ? 'center' : 'flex-start',
            background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: 'var(--text-3)',
            fontFamily: 'inherit',
          }}>
            {collapsed ? '←' : 'Sign out'}
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, overflow: 'auto', padding: 32, maxWidth: 'calc(100vw - 210px)' }}>
        <Outlet />
      </main>
    </div>
  );
}
